import { render } from "./SingleSliderWithTwoColors.vue?vue&type=template&id=05fcc218&scoped=true"
import script from "./SingleSliderWithTwoColors.vue?vue&type=script&lang=js"
export * from "./SingleSliderWithTwoColors.vue?vue&type=script&lang=js"

import "./SingleSliderWithTwoColors.vue?vue&type=style&index=0&id=05fcc218&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fcc218"]])

export default __exports__